import { api } from "../AxiosInstance";
import {
  IOnboardingUser,
  IOnboardingFormData,
  IOnboardingResponse,
  IOnboardingFilters,
  IOnboardingTableData,
} from "../interfaces/onboarding.interface";
import { generateIdentifier } from "../utils/identifierGenerator";

const OnboardingService = {
  // Enterprise Admin Registration
  createEnterpriseAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post(
        "/enterprise/registration/enterprise-admin",
        {
          name: data.name,
          username: data.username,
          email: data.email,
          password: data.password,
          phoneNumber: data.phoneNumber,
          identifier: data.identifier,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error creating enterprise admin:", error);
      throw error;
    }
  },

  // Federation Admin Registration (Under Enterprise)
  createFederationAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post("/enterprise/registration/fed-admin", {
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        identifier: data.identifier,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error creating federation admin:", error);
      throw error;
    }
  },

  // Transporter Admin Registration (Under Enterprise)
  createTransporterAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post(
        "/enterprise/registration/transporter-admin",
        {
          name: data.name,
          username: data.username,
          email: data.email,
          password: data.password,
          phoneNumber: data.phoneNumber,
          identifier: data.identifier,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error creating transporter admin:", error);
      throw error;
    }
  },

  // Federation Admin Registration (Independent)
  createIndependentFederationAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post("/fed/registration/fed-admin", {
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        identifier: data.identifier,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error creating independent federation admin:", error);
      throw error;
    }
  },

  // Transporter Admin Registration (Under Federation)
  createFederationTransporterAdmin: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post("/fed/registration/transporter-admin", {
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        identifier: data.identifier,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error creating federation transporter admin:", error);
      throw error;
    }
  },

  // Independent Transporter Registration
  createIndependentTransporter: async (
    data: IOnboardingFormData
  ): Promise<IOnboardingResponse> => {
    try {
      const response = await api.post("/transporter/registration", {
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        phoneNumber: data.phoneNumber,
        identifier: data.identifier,
      });
      return response.data;
    } catch (error: any) {
      console.error("Error creating independent transporter:", error);
      throw error;
    }
  },

  // Get Transporters for Enterprise
  getEnterpriseTransporters: async (): Promise<IOnboardingUser[]> => {
    try {
      const response = await api.get("/enterprise/transporters");
      return response.data;
    } catch (error: any) {
      console.error("Error fetching enterprise transporters:", error);
      throw error;
    }
  },

  // Get Federations for Enterprise
  getEnterpriseFederations: async (): Promise<IOnboardingUser[]> => {
    try {
      const response = await api.get("/enterprise/federations");
      return response.data;
    } catch (error: any) {
      console.error("Error fetching enterprise federations:", error);
      throw error;
    }
  },

  // Get Transporters for Federation
  getFederationTransporters: async (): Promise<IOnboardingUser[]> => {
    try {
      const response = await api.get("/fed/transporters");
      return response.data;
    } catch (error: any) {
      console.error("Error fetching federation transporters:", error);
      throw error;
    }
  },
};

export default OnboardingService;
